// extracted by mini-css-extract-plugin
export default {"header":"SectionHeader_header__MyIzR","num":"SectionHeader_num__ZTpOu","title":"SectionHeader_title__PZFBP","line":"SectionHeader_line__nn9as"};